export class VtsEvent {
    typeId: any;
}
